/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Entry_BodyInputs */

const en_us2_progress_report_entry_body = /** @type {(inputs: Progress_Report_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets per muscle, distribution, exercises that progress, and records.`)
};

const pt_br2_progress_report_entry_body = /** @type {(inputs: Progress_Report_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries por músculo, distribuição, exercícios que progridem e recordes.`)
};

const es_419_progress_report_entry_body = /** @type {(inputs: Progress_Report_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series por músculo, distribución, ejercicios que progresan y récords.`)
};

const pt_pt2_progress_report_entry_body = /** @type {(inputs: Progress_Report_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries por músculo, distribuição, exercícios que progridem e recordes.`)
};

const fr_fr2_progress_report_entry_body = /** @type {(inputs: Progress_Report_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries par muscle, répartition, exercices qui progressent et records.`)
};

const de_de2_progress_report_entry_body = /** @type {(inputs: Progress_Report_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze pro Muskel, Verteilung, Übungen mit Fortschritt und Rekorde.`)
};

const it_it2_progress_report_entry_body = /** @type {(inputs: Progress_Report_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie per muscolo, distribuzione, esercizi che progrediscono e record.`)
};

/**
* | output |
* | --- |
* | "Sets per muscle, distribution, exercises that progress, and records." |
*
* @param {Progress_Report_Entry_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_entry_body = /** @type {((inputs?: Progress_Report_Entry_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Entry_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_entry_body(inputs)
	if (locale === "es-419") return es_419_progress_report_entry_body(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_entry_body(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_entry_body(inputs)
	if (locale === "de-DE") return de_de2_progress_report_entry_body(inputs)
	if (locale === "it-IT") return it_it2_progress_report_entry_body(inputs)
	return en_us2_progress_report_entry_body(inputs)
});
export { progress_report_entry_body as "progress-report.entry_body" }